import React from 'react';
import { useNavigate } from 'react-router-dom';
import CoverPlate from './CoverPlate';
import Icon from './Icon';
import { fmtViews } from '../../utils/format';

export default function VideoCard({ video, compact = false, onClick }) {
    const navigate = useNavigate();

    return (
        <a
            href={`/watch/${video.id}`}
            onClick={(e) => { e.preventDefault(); onClick ? onClick() : navigate(`/watch/${video.id}`); }}
            style={{
                display: 'flex', flexDirection: 'column', gap: 8,
                textDecoration: 'none', padding: 0,
                cursor: 'pointer', color: 'inherit', width: '100%',
            }}
        >
            <CoverPlate video={video} size={compact ? 'sm' : 'md'} />
            <div style={{ padding: '0 2px' }}>
                <div style={{
                    fontSize: compact ? 12 : 13.5, fontWeight: 600, lineHeight: 1.3,
                    color: '#fff',
                    display: '-webkit-box', WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical', overflow: 'hidden',
                    minHeight: compact ? '31.2px' : '35.1px',
                }}>
                    {video.title}
                </div>
                <div style={{
                    marginTop: 4,
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: 12, color: '#71717A',
                    display: 'flex', alignItems: 'center', gap: 6,
                }}>
                    <Icon name="eye" size={12} color="#71717A" stroke={1.5} />
                    {fmtViews(video.views)}
                    <span style={{ width: 2, height: 2, borderRadius: 2, background: '#3F3F46', display: 'inline-block' }} />
                    <Icon name="heart" size={12} color="#71717A" stroke={1.5} />
                    {fmtViews(video.likes_count || 0)}
                </div>
            </div>
        </a>
    );
}
